import React from 'react'
import { useTranslation } from 'react-i18next'
import { selectedVersionsVar } from '../../../apollo/reactive-vars'
import { CostType } from '../../../generated/graphql'
import { Section } from '../../common/Section'
import { sortGroupedCosts } from '../cost-tables/CostsTables'
import { EnergyCostsTable } from '../cost-tables/EnergyCostsTable'
import { FixedCostsTable } from '../cost-tables/FixedCostsTable'
import { useCostTables } from '../cost-tables/use-cost-tables'
import { ReportVersionsDivider } from './ReportVersionsDivider'

export default function CostsBreakdownReport(): React.ReactElement {
  const { t } = useTranslation()
  const { groupProjectCostsByCostType } = useCostTables()
  const selectedVersions = selectedVersionsVar()

  const groupedCostsByCostType = groupProjectCostsByCostType()
  return (
    <>
      <Section printPadding title={t(`costs.energyAccordionTitle`)}>
        <ReportVersionsDivider
          versions={selectedVersions}
          component={EnergyCostsTable}
        />
      </Section>

      {Object.keys(CostType).map((type) => (
        <Section printPadding key={type} title={t(`costType.${type}`)}>
          <ReportVersionsDivider
            versions={selectedVersions}
            component={FixedCostsTable}
            componentProps={{
              groupedCosts: sortGroupedCosts(
                groupedCostsByCostType[type as CostType],
                t,
              ),
              type: type as CostType,
              updateCost: () => {},
              createNewCost: () => {},
            }}
          />
        </Section>
      ))}
    </>
  )
}
